export default {
  tabMenu: {
    view: 'Übersicht',
    alarm: 'Störungen',
    loadList: 'Chargen',
    movements: 'Bewegungen',
    gantt: 'Planungsgrafik',
    loadingPlace: 'Ladeplatz',
  },
};
